module.exports = __webpack_public_path__ + "img/y@2x.ed7e9b27.jpg";